import { http } from '@/core/api/';

const apiBaseUrl = '/api/triannualstudentevaluation';

export default {
  /**
   *
   * @param evaluationDateId
   */
  async getExistingDocuments(evaluationDateId) {
    return await http.get(`${apiBaseUrl}/documents/${evaluationDateId}`);
  },
  /**
   * Get All Impediments than require multiple evaluations
   */
  async getRequiredMultipleImpediments() {
    return await http.get(
      `${apiBaseUrl}/impedimentsRequiresMultipleEvaluations`
    );
  },
  /**
   * Get All Impediments than require evaluations
   */
  async getImpedimentsEvaluations() {
    return await http.get(`${apiBaseUrl}/impedimentEvaluations`);
  },
  /**
   * Get Evaluation Information
   * @param id
   */
  async getEvaluation(id) {
    return await http.get(`${apiBaseUrl}/${id}/evaluationDateInfo`);
  },
  /**
   * Get Impediments
   */
  async getImpediments() {
    return await http.get(`${apiBaseUrl}/gettrianualfilteredimpediments`);
  },
  /**
   * Get Not Impediments
   */
  async getNotImpediments() {
    return await http.get(`${apiBaseUrl}/trianualnotimpediments`);
  },
  /**
   * Get MUltiples Impediments
   */
  async getImpedimentsMultiple() {
    return await http.get(
      `${apiBaseUrl}/gettrianualfilteredmultipleimpediments`
    );
  },
  /**
   * Get Severities
   */
  // ! Change this methods to common api
  async getSeverities() {
    return await http.get('api/code/GetEduEspCodes?codeType=7');
  },
  async getDisorders() {
    return await http.get('api/code/GetEduEspCodes?codeType=8');
  },
  async getEligibilityDeterminationConditions() {
    return await http.get(`${apiBaseUrl}/eligibilitydeterminationconditions`);
  },
  async getEvauationSelectedOrRegister(studentSieId,academicYearId) {
    return await http.get(`/api/studentevaluation/selectedevaluationsorregister/${studentSieId}`,
    {
      params: {
        academicYearId
      }
    });
  },
};


